import { useNavigate } from "react-router-dom";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center px-4 min-w-80">
      <h1 className="text-4xl font-bold text-gray-800 mb-2">Seite nicht gefunden</h1>
      <p className="text-gray-600 mb-6">Die aufgerufende Seite ist nicht verfügbar</p>
      <button
        onClick={() => navigate("/")}
        className="bg-[#2F4F2F] hover:bg-[#37813b] text-white font-medium py-2.5 px-6 rounded-xl transition-colors"
      >
        Back To Home
      </button>
    </div>
  );
};
